import React, { useState } from "react";
import { Icon, ImageEditor, ModalDialog, PlainButton } from "@culturehq/components";

import { getImage, getSearchValue, Trans } from "app/utils";
import FindImageOnUnsplash from "components/FindImageOnUnsplash";
import imagesSizes from "constants/imagesSizes";
import ImageControl from "components/editor/controls/ImageControl";
import { useProfile } from "app/context";
import hasCustomImageLibrary from "app/utils/hasCustomImageLibrary";
import CustomImageLibrary from "components/stories/post-stories-v2/common/PostStoryForm/custom-image-library/CustomImageLibrary";
import ChqModalDialog from "./ChqModalDialog";

const SelectImage = ({
  previewTitle = "",
  buttonTitle = "",
  fieldTitle = "",
  mediaType = "image",
  storyQuestion = undefined,
  imageToShow = "",
  aspectRatio = 1 / 1,
  onImageSelected
}) => {
  const [showUnsplashSearch, setShowUnsplashSearch] = useState(false);
  const [selectedImage, setSelectedImage] = useState(imageToShow);
  const [imageToCrop, setImageToCrop] = useState();
  const [searchValue] = useState(getSearchValue(storyQuestion));
  const { profile: { organization: { name: orgName } } } = useProfile();
  const hasLibrary = hasCustomImageLibrary(orgName);

  const handleSelectImage = image => {
    setImageToCrop(getImage(imagesSizes.NORMAL, image));
    setShowUnsplashSearch(false);
  };

  const handleCroppedImage = image => {
    onImageSelected(imageToCrop, image);
    setImageToCrop(undefined);
    setSelectedImage(URL.createObjectURL(image));
  };

  const handleFindOnUnsplash = value => {
    setShowUnsplashSearch(value);
  };

  const onImageReady = (editedImage, originalImage) => {
    setSelectedImage(editedImage[0].src);
    onImageSelected(originalImage.file, editedImage[0].file);
  };

  const handleClose = () => {
    setImageToCrop(undefined);
  };

  return (
    <div className="Select-Image">
      <p className="Story-Share-Modal__label">
        <Trans>{fieldTitle || "Banner Image"}</Trans>
      </p>
      <div className="image-container">
        {selectedImage ? (
          <>
            <div className="gallery-lightbox__image-container" style={{ backgroundImage: `url(${getImage(imagesSizes.SMALL, selectedImage)})` }} />
            <img className="image" src={getImage(imagesSizes.SMALL, selectedImage)} alt="Selected" />
          </>
        ) : (
          <div className="Empty-Image">
            <Icon icon="image" />
            <Trans>{previewTitle || "Add banner image"}</Trans>
          </div>
        )}
      </div>
      <div className="Select-Image__Buttons">
        <ImageControl
          buttonView
          singleImage
          buttonTitle={buttonTitle}
          mediaType={mediaType}
          aspectRatio={aspectRatio}
          onImagesSelected={onImageReady}
        />
        <PlainButton className="unsplash-btn" onClick={() => { setShowUnsplashSearch(!showUnsplashSearch); }}>
          <Icon icon="search" /><Trans>{hasLibrary ? "Find Images" : "Search Unsplash"}</Trans>
        </PlainButton>
      </div>
      {showUnsplashSearch && (
        <div style={{ position: "relative" }}>
          {
            hasLibrary ? (
              <CustomImageLibrary
                inline
                organizationName={orgName}
                onSelectImage={handleSelectImage}
              />
            ) : (
              <FindImageOnUnsplash
                inline
                onSelectImage={handleSelectImage}
                search={searchValue}
                showSearch={handleFindOnUnsplash}
              />
            )
          }
        </div>
      )}
      {imageToCrop && (
        <ChqModalDialog onClose={handleClose}>
          <ModalDialog.Body>
            <ImageEditor
              aspectRatio={aspectRatio}
              image={imageToCrop}
              onEdit={handleCroppedImage}
            />
          </ModalDialog.Body>
        </ChqModalDialog>
      )}
    </div>
  );
};

export default SelectImage;
